// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/square-stack.js';

import { paths } from '../generated/square-stack';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('square-stack', Original, paths);
